import $ from 'jquery';
// JavaScript source code

function filter() {
    if (document.getElementById("myFilter").style.height === "") {
        document.getElementById("myFilter").style.height = "100%";
        document.getElementById("myFilter").style.opacity = "1";
        document.getElementById("icon").classList.remove('fa-filter');
        document.getElementById("icon").classList.add('fa-chevron-left');
        document.getElementById("icon-text").innerHTML = "Fechar";
        document.getElementById("filter-arrow").style.display = "none";
        document.getElementById("filter-btn").style.backgroundColor = "#f6f8ff";
        disable_scroll();
    } else {
        document.getElementById("myFilter").style.height = "";
        document.getElementById("myFilter").style.opacity = "";
        document.getElementById("icon").classList.remove('fa-chevron-left');
        document.getElementById("icon").classList.add('fa-filter');
        document.getElementById("icon-text").innerHTML = "Abrir Filtros";
        document.getElementById("filter-arrow").style.display = "block";
        document.getElementById("filter-btn").style.backgroundColor = "white";
        enable_scroll();
    }
}

function disable_scroll() {
    var element = document.body;
    element.classList.toggle("overlay-body");
    element.classList.toggle("noscroll");
}

function enable_scroll() {
    var element = document.body;
    element.classList.remove("overlay-body");
    element.classList.remove("noscroll");
}


$(".collapse-title").click(function () {
    $(this).toggleClass("collapsed");
    $(this).next(".collapse").toggle();
});

$(".dropdown .dropdown-menu a").click(function () {
    var selText = $(this).text();
    var drop = $(this).closest(".dropdown").find('.label');
    $(drop).html("<strong>" + selText + "</strong>  <i class='fas fa-angle-down fa-xs'></i>");
});

$(".filter-btn").click(function () {
    var drop = $('.filtro');

    $(this).toggleClass("active");
    drop.toggleClass("active");
});

$(document).ready(function () {
    $(".sub-menu .collapse-btn").click(function () {

        // $(".sub-menu .third-menu").removeClass("show");

        $(this).next().toggleClass("show");
    });
});

function nav() {
    if (document.getElementById("myNav").style.height === "") {
        document.getElementById("myNav").style.height = "100%";
        document.getElementById("myNav").style.opacity = "1";
        disable_scroll();
    } else {
        document.getElementById("myNav").style.height = "";
        document.getElementById("myNav").style.opacity = "";
        enable_scroll();
    }
}

$(".small-menu .main").click(function () {
    var previous = $(this).parent();

    previous.toggleClass("active");
});

$(".small-menu .main").click(function () {
    $(this).toggleClass("collapsed");
    $(this).next(".collapse").toggle();
});

$(".sub .main").click(function () {
    $(this).toggleClass("collapsed");
    $(this).next(".collapse").toggle();
});


$(function () {
    var $heightTest = $('footer');
    var $footerAltura = $heightTest.innerHeight();
    var $screenW = $(window).width();
    var $screenH = $(window).height();
    //console.log($screenW);

    var divH = 'calc(100% - ' + $footerAltura + 'px)';

    // $('.main-div .content').css('height', divH);




});


var slickopts = {
    // autoplay: 5000,
    // loop: true,
    // speed: 2800,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    rows: 1,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            infinite: false,
        }
    },
    ]
};


$('.carousel').slick(slickopts);


